import axios from "axios"

export const sibTrackEmail = (email_entered, sib_email, setSibEmail)=>{ 
    if(email_entered !== sib_email && window.sendinblue){
        setSibEmail(email_entered);
        var event_name = "checkout_started_ttm";
        var properties = {
            "email": email_entered,
            //"first_name": "{{first name}}",
            //"last_name": "{{last name}}"
        };

        var event_data = {
            //"id": "{{recurly plan code}}",
            "data": {
                "cart_url": window.location.href,
                "products": [{
                    //"sku": "{{recurly plan code}}",
                    //"name": "{{recurly plan name}}",
                }],
                //"wedding_date" : "{{yyyy-mm-dd}}",
                //"gift": {{boolean}}  
            }
        };

        window.sendinblue.track(
            event_name,
            properties,
            event_data
        );
    }
}

//Gift message event
export const sibGiftMsg = async (email, message) => {
    let values = {
        email: email,
        message: message
    }
    try{
        const response = await axios.post("/wp-admin/admin-ajax.php?action=sib_gift_msg", values);
        return response;
    }catch{
        return false;
    }
}

//Gift message event
export const sibCheckoutSms = async (email, event, data) => {
    let values = {
        email: email,
        event: event,
        data: data
    }
    try{
        const response = await axios.post("/wp-admin/admin-ajax.php?action=sib_event", values);
        return response;
    }catch{
        return false;
    }
}

export const sibUpdateContact = async (email, attr) =>{
    let values = {
        email: email,
        attr: attr
    }
    await axios.post("/wp-admin/admin-ajax.php?action=sib_update_contact", values).then(response => {
        return response;
      }).catch(error=>{
        console.log(error);
      });
}


export const sendEmail = async (to, name_to, var_from, name, subject, contents) => {
    const values = "name=" + name + 
                  "&name_to="+ name_to +
                  "&to="+ to +
                  "&from=" + var_from + 
                  "&subject=" + subject + 
                  "&contents=" + contents;
    const response = await fetch('/wp-admin/admin-ajax.php?action=sib_send_email2&'+values);
    return response.json();
}

export const sibEvent = async (email, event, data) => {
    let values = {
        email: email,
        event: event,
        data: data
    }
    try{
        const response = await axios.post("/wp-admin/admin-ajax.php?action=sib_event", values);
        return response;
    }catch{
        return false;
    }
}
  
export const sibAdd = async (email, listId)=>{
    var values = 'email='+email+"&list_id=" + listId;
    const response = await fetch('/wp-admin/admin-ajax.php?action=sib_signup&' + values);
    return response.json();
}
  